function hashEmail(email) {
  const norm = String(email || "")
    .toLowerCase()
    .trim();
  let hash = 0;
  for (let i = 0; i < norm.length; i++) {
    hash = norm.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
}

/** Color estable y distinguible por dirección de cuenta. */
export function accountColor(email) {
  if (!email || !String(email).includes("@")) return "#64748b";
  const hue = hashEmail(email) % 360;
  return `hsl(${hue}, 62%, 40%)`;
}

function parseHsl(color) {
  const match = color.match(/hsl\((\d+),\s*(\d+)%,\s*(\d+)%\)/);
  if (!match) return null;
  return { h: Number(match[1]), s: Number(match[2]), l: Number(match[3]) };
}

/** Estilos de chip para la cuenta receptora en listas. */
export function accountChipSx(email, neutral = {}) {
  if (!email || !String(email).includes("@")) {
    return {
      bgcolor: neutral.metaBg || "rgba(100, 116, 139, 0.1)",
      borderColor: neutral.border || "rgba(100, 116, 139, 0.28)",
      color: neutral.textMuted || "#64748b",
      fontWeight: 600,
    };
  }

  const color = accountColor(email);
  const hsl = parseHsl(color);
  if (!hsl) {
    return { color, fontWeight: 700 };
  }

  return {
    bgcolor: `hsla(${hsl.h}, ${hsl.s}%, ${hsl.l}%, 0.14)`,
    borderColor: `hsla(${hsl.h}, ${hsl.s}%, ${hsl.l}%, 0.4)`,
    color,
    fontWeight: 700,
  };
}

/** Color suave para acentos en filas (barra lateral, menos saturación). */
export function accountColorSoft(email) {
  if (!email || !String(email).includes("@")) return "rgba(100, 116, 139, 0.32)";
  const hue = hashEmail(email) % 360;
  return `hsl(${hue}, 42%, 50%)`;
}

/** Badge de no leídos / punto de cuenta: color sólido por buzón. */
export function accountBadgeColor(email) {
  if (!email || !String(email).includes("@")) return "#00bbcd";
  const hue = hashEmail(email) % 360;
  return `hsl(${hue}, 58%, 42%)`;
}

/** Versión clara del badge (leídos, sin número). */
export function accountBadgeColorSoft(email) {
  if (!email || !String(email).includes("@")) return "hsla(187, 70%, 42%, 0.28)";
  const hue = hashEmail(email) % 360;
  return `hsla(${hue}, 48%, 52%, 0.32)`;
}

/** Tinte de fila: borde de cuenta + barra lateral un poco más marcada. */
export function accountRowTint(email) {
  if (!email || !String(email).includes("@")) return null;

  const hue = hashEmail(email) % 360;

  return {
    accent: `hsl(${hue}, 46%, 48%)`,
    border: `hsl(${hue}, 30%, 76%)`,
    borderHover: `hsl(${hue}, 34%, 68%)`,
    bg: `hsl(${hue}, 24%, 97.5%)`,
    bgHover: `hsl(${hue}, 26%, 95.5%)`,
    barWidth: 3,
  };
}

export function resolveRowTintEmail(accountList = [], lastAccountEmail = "") {
  if (accountList.length === 1) return accountList[0];
  if (accountList.length > 1) return null;
  const fromLast = String(lastAccountEmail || "").trim();
  if (fromLast.includes("@")) return fromLast;
  return null;
}
